import '@scss/index.scss'
import './sections'

import { onReady } from './sections/Registry'

document.addEventListener('DOMContentLoaded', () => {
    onReady.forEach(fn => fn())
})